/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-body[_ngcontent-%COMP%]{max-height:500px;overflow-y:auto}"];
export { styles as styles };
